export default __webpack_public_path__ + "media/images/paylogos/gray/visa_verified-cf4b1f595df2106580232bb1eec61a01.png";